var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',{staticClass:"c-page-mask-loading"},[_c('a-spin',[_c('a-icon',{staticStyle:{"font-size":"60px"},attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }